import React, { useState } from 'react';
import { Segment, Button, Form, Header, Radio, Checkbox, Grid, Input } from 'semantic-ui-react';
import questionsData from './q_psqi.json';

const SymptomAssessment = () => {
  // Flatten questions for state
  const flattenQuestions = () => {
    const flat = [];
    questionsData.mainQuestions.forEach(q => flat.push(q));
    questionsData.bedPartnerQuestions.forEach(q => flat.push(q));
    return flat;
  };

  const allQuestions = flattenQuestions();

  // Initialize state
  const initialAnswers = {};
  allQuestions.forEach(q => {
    initialAnswers[q.key] = q.type === 'checkbox' ? false : '';
  });
  const [answers, setAnswers] = useState(initialAnswers);

  // Handlers
  const handleChange = (e, { name, value }) => setAnswers({ ...answers, [name]: value });
  const handleCheckboxChange = (e, { name, checked }) => setAnswers({ ...answers, [name]: checked });

  // PSQI scoring function
  const calculatePSQIScore = () => {
    let componentScores = {
      sleepQuality: parseInt(answers.q1 || 0),
      sleepLatency: 0,
      sleepDuration: 0,
      sleepEfficiency: 0,
      sleepDisturbances: 0,
      sleepMedication: parseInt(answers.q15 || 0),
      daytimeDysfunction: 0
    };

    const q2 = parseInt(answers.q2 || 0);
    const q3 = parseInt(answers.q3 || 0);
    componentScores.sleepLatency = Math.min(q2 + q3, 3);

    const q4 = parseInt(answers.q4 || 0);
    componentScores.sleepDuration = q4;

    let sumDisturbances = 0;
    for (let i = 5; i <= 13; i++) sumDisturbances += parseInt(answers[`q${i}`] || 0);
    if (sumDisturbances === 0) componentScores.sleepDisturbances = 0;
    else if (sumDisturbances <= 9) componentScores.sleepDisturbances = 1;
    else if (sumDisturbances <= 18) componentScores.sleepDisturbances = 2;
    else componentScores.sleepDisturbances = 3;

    const daySum = (parseInt(answers.q16 || 0) + parseInt(answers.q17 || 0));
    if (daySum === 0) componentScores.daytimeDysfunction = 0;
    else if (daySum <= 2) componentScores.daytimeDysfunction = 1;
    else if (daySum <= 4) componentScores.daytimeDysfunction = 2;
    else componentScores.daytimeDysfunction = 3;

    // Sleep efficiency
    const bedtime = answers.q18;
    const wakeup = answers.q19;
    const sleepHours = [">7 hours","6–7 hours","5–6 hours","<5 hours"].indexOf(answers.q4) + 1;
    if (bedtime && wakeup) {
      const [bh, bm] = bedtime.split(":").map(Number);
      const [wh, wm] = wakeup.split(":").map(Number);
      let timeInBed = wh + wm/60 - (bh + bm/60);
      if (timeInBed < 0) timeInBed += 24;
      const efficiency = (sleepHours / timeInBed) * 100;
      if (efficiency >= 85) componentScores.sleepEfficiency = 0;
      else if (efficiency >= 75) componentScores.sleepEfficiency = 1;
      else if (efficiency >= 65) componentScores.sleepEfficiency = 2;
      else componentScores.sleepEfficiency = 3;
    }

    const globalScore = Object.values(componentScores).reduce((a,b)=>a+b,0);
    return { componentScores, globalScore };
  };

  const handleSubmit = () => {
    const { componentScores, globalScore } = calculatePSQIScore();
    console.log("Component Scores:", componentScores);
    console.log("Global PSQI Score:", globalScore);
    alert(`PSQI Submitted!\nGlobal Score: ${globalScore}`);
  };

  return (
    <Segment basic style={{ padding: '15em 2em', minWidth: '100wh', minHeight: '100vh', backgroundColor: '#f5f5f5' }}>
      <Grid centered>
        <Grid.Row>
          <Header as="h2" textAlign="center">PSQI - Pittsburgh Sleep Quality Index</Header>
        </Grid.Row>
        <Grid.Row>
          <Form style={{
            width: '100%',
            maxWidth: '800px',
            margin: '0 auto',
            backgroundColor: 'white',
            padding: '2em',
            borderRadius: '10px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
          }}>
            {allQuestions.map(q => (
              <Form.Field key={q.key} style={{ marginBottom: '1.5em', textAlign: 'left' }}>
                <label style={{ fontWeight: 'bold', fontSize: '20px' }}>{q.q}</label>
                {q.type === 'time' ? (
                  <Input
                    type="time"
                    name={q.key}
                    value={answers[q.key]}
                    onChange={e => setAnswers({...answers, [q.key]: e.target.value})}
                    style={{fontSize: '20px',  marginTop: '0.5em' }}
                  />
                ) : q.type === 'text' ? (
                  <Input
                    type="text"
                    name={q.key}
                    value={answers[q.key]}
                    onChange={e => setAnswers({...answers, [q.key]: e.target.value})}
                    style={{ fontSize: '20px', marginTop: '0.5em' }}
                  />
                ) : q.type === 'checkbox' ? (
                  <Checkbox
                    name={q.key}
                    checked={answers[q.key]}
                    onChange={handleCheckboxChange}
                    style={{ fontSize: '20px', display: 'block', marginTop: '0.5em' }}
                  />
                ) : (
                  <Form.Group grouped style={{ marginTop: '0.5em' }}>
                    {q.options.map((opt, i) => (
                      <Form.Field key={i} style={{ display: 'block', marginTop: '0.25em' }}>
                        <Radio
                          label={opt}
                          name={q.key}
                          value={i.toString()}
                          checked={answers[q.key] === i.toString()}
                          onChange={handleChange}
                          style={{ fontSize: '20px' }}
                        />
                      </Form.Field>
                    ))}
                  </Form.Group>
                )}
              </Form.Field>
            ))}

            <Button color='#302d4a' onClick={handleSubmit} style={{ marginTop: '2em' }}>
              Submit Assessment
            </Button>
          </Form>
        </Grid.Row>
      </Grid>
    </Segment>
  );
};

export default SymptomAssessment;
